import { DateRangeTuple } from "./inputs";
import { StringIndexedDictionary } from "./utility";
import { DynamicDateValue } from "../components/atoms/inputs/FlowioDynamicDateInput";
import { DateType, TemplateId } from ".";

export enum WhereItemGate {
  And = "and",
  Or = "or",
}

export type WhereItemDict = StringIndexedDictionary<WhereItem[]>;

export enum RelationType {
  TextValue = "textValue",
  NumberValue = "numberValue",
  BooleanValue = "booleanValue",
  DateValue = "dateValue",
  DateValueRange = "dateValueRange",
  DateValueDynamic = "dateValueDynamic",
  Like = "like",
  Null = "isnull",
  DynamicValue = "dynamicValue",
  SelectValue = "selectValue",
  EwaLogin = "ewaLogin",
  EwaUsername = "ewaUsername",
  HegLogin = "hegLogin",
  HegUsername = "hegUserName",
}

export enum OperatorEnum {
  eq = "=",
  neq = "≠",
  lt = "<",
  gt = ">",
  leq = "≤",
  geq = "≥",
}

export type OperatorType = keyof typeof OperatorEnum;

export enum Gate {
  And = "and",
  Or = "or",
}

export interface TemplateDescriptor {
  templateIdentifier?: TemplateId | null;
}
export interface TableDescriptor extends TemplateDescriptor {
  tableIdentifier: string | null;
}
export interface ColumnDescriptor extends TableDescriptor {
  columnIdentifier: string | null;
}
export interface Relation {
  type: RelationType;
  operator: OperatorType;
}

export interface ValueShape {
  numberVal: string | number | null;
  stringVal: string | null;
  booleanVal: boolean | null;
  selectVal: string | null;
  dateVal: DateType | null;
  dateValRange: DateRangeTuple | null;
  dateValDynamic: DynamicDateValue | null;
  targetColumnVal: ColumnDescriptor | null;
}

export interface WhereItem {
  id: string;
  gate: Gate;
  source: ColumnDescriptor;
  relation: Relation;
  searchValue: ValueShape;
  isList: boolean;
  children: this[];
  disabled: boolean;
}

export type WhereItems = WhereItem[];
